import { Button } from './Button'
import { Sheet } from './Sheet'
import './ConfirmSheet.css'

interface ConfirmSheetProps {
  open: boolean
  heading: string
  message?: string
  confirmLabel: string
  danger?: boolean
  onConfirm: () => void
  onCancel: () => void
  children?: React.ReactNode
}

/** A small question with one confirming action and Cancel. */
export function ConfirmSheet({ open, heading, message, confirmLabel, danger = false, onConfirm, onCancel, children }: ConfirmSheetProps) {
  return (
    <Sheet open={open} onClose={onCancel} heading={heading} variant="dialog" headerEnd={<span />}>
      {message && <p className="confirm__message">{message}</p>}
      {children}
      <div className="confirm__actions">
        <Button variant={danger ? 'danger' : 'primary'} size="lg" block onClick={onConfirm}>
          {confirmLabel}
        </Button>
        <Button variant="quiet" size="lg" block onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </Sheet>
  )
}

interface ChoiceSheetProps {
  open: boolean
  heading: string
  message?: string
  choices: { key: string; label: string; hint?: string }[]
  onChoose: (key: string) => void
  onCancel: () => void
  children?: React.ReactNode
}

/** A question with a short list of answers, such as "Check back when?". */
export function ChoiceSheet({ open, heading, message, choices, onChoose, onCancel, children }: ChoiceSheetProps) {
  return (
    <Sheet open={open} onClose={onCancel} heading={heading} variant="dialog">
      {message && <p className="confirm__message">{message}</p>}
      <div className="confirm__choices">
        {choices.map((c) => (
          <button type="button" key={c.key} className="confirm__choice" onClick={() => onChoose(c.key)}>
            <span>{c.label}</span>
            {c.hint && <span className="confirm__choice-hint">{c.hint}</span>}
          </button>
        ))}
      </div>
      {children}
    </Sheet>
  )
}
